import type { SVGProps } from 'react';

const SvgError = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 2a10 10 0 1 0 10 10A10.029 10.029 0 0 0 12 2Zm0 16.429a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Zm1.25-3.75h-2.5V5.571h2.5v9.108Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgError;
